import React, { createContext, ReactNode, useContext } from 'react';

import { TourBuilderStore } from '../domain/tourBuilderStore';
import { StoreApi, useStore } from 'zustand';

const TourBuilderContext = createContext<StoreApi<TourBuilderStore> | undefined>(undefined);

export const TourBuilderStoreProvider = (props: { children: ReactNode; store: StoreApi<TourBuilderStore> }) => {
  return <TourBuilderContext.Provider value={props.store}>{props.children}</TourBuilderContext.Provider>;
};

export const useTourBuilderStore = () => {
  const store = useContext(TourBuilderContext);
  if (!store) {
    throw new Error('TourBuilderStore is missing in context');
  }

  return store;
};

export const useStoreForSelectorFile = () => {
  const store = useContext(TourBuilderContext);
  if (!store) {
    throw new Error('TourBuilderStore is missing in context');
  }

  return store;
};

export const useTourBuilderStoreActions = () => {
  const store = useStoreForSelectorFile();

  return useStore(store, (store) => store.actions);
};
